import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Name Space Info.", -1)
const _hoisted_3 = { style: {"text-align":"left"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Id", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Name", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Owner", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { style: {"color":"#409EFF"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["element-loading-spinner"]
const _hoisted_12 = { style: {"margin":"0 auto","text-align":"center","margin-top":"10px"} }

import { h, ref } from "vue"
import Resolution from "@unstoppabledomains/resolution"
import { toRaw } from '@vue/reactivity'
import { genFileId } from 'element-plus'

import type { UploadInstance, UploadProps, UploadRawFile, UploadFile, UploadFiles } from 'element-plus'

import { connected, networkConnect, connectState } from "../libs/connect"
import { FileNameSpace } from "../libs/filenamespace"

import * as element from "../libs/element"
import * as tools from "../libs/tools"
import * as storage from '../libs/storage'
import * as w3name from "../libs/w3name"
import * as constant from "../constant"
import * as crypto from "../libs/crypto"


const __default__ = {
  name: 'NamesPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const resolution = new Resolution();

const uploadAvatar = ref<UploadInstance>();
const avatarFileList = ref(new Array());

const searchContent = ref('');
const filenamespace = new FileNameSpace();
const nameLists = ref(new Array());
const loadStatus = ref(false);
const loadDrawerStatus = ref(false);
const showNameSpaceVisiable = ref(false);

const inputNameKey = ref('');
const inputNameValue = ref('');

const nameDetailInfo = ref({
  nameId: 0,
  name: name,
  url: '',
  publicKey: '',
  privateKey: '',
  owner: '',
  oldOwner: '',
  updated: false,
});

const hasMore = ref(false);
const pageSize = ref(9);
const pageCount = ref(0);

//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}     

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
}; 

//on avatar file change
const onChangeSelectAvatarFile = async (uploadFile: UploadFile, uploadFiles: UploadFiles) => {
  avatarFileList.value = toRaw(uploadFiles);

  nameDetailInfo.value.url = URL.createObjectURL((avatarFileList.value[0].raw as any));
}

//on click to select avatar file
const onSelectAvatarFile = async () => {
  uploadAvatar.value!.clearFiles();
}

//replace the avatar file from old selected to new one
const handleAvtarExceed: UploadProps['onExceed'] = (files:any) => {
  uploadAvatar.value!.clearFiles();
  const file = files[0] as UploadRawFile;
  file.uid = genFileId();
  uploadAvatar.value!.handleStart(file);
};

const onClickToSearch = async () => {
  tools.setUrlParamter('nameId', '0');
  
  searchContent.value = searchContent.value.trim();
  if(searchContent.value === ''){
    handleClick();
    return;
  }

  let searchName = searchContent.value;
  if(searchName.endsWith(constant.nameSpaceSurfix) === false){
    searchName = searchName + constant.nameSpaceSurfix;
  }
  
  const nameInfo = await filenamespace.getNameInfoByName(searchName);
  if(nameInfo.nameId > 0){
    const newList = new Array();
    nameInfo.isOwner = nameInfo.owner.toLowerCase() === connectState.userAddr.value.toLowerCase();
    nameInfo.updated = nameInfo.owner === nameInfo.oldOwner;
    newList.push(nameInfo);
    nameLists.value = newList;
    return;
  }

  try{
    const newList = new Array();
    const names = await filenamespace.resolveByAddress(searchContent.value);
    for(const i in names){
      const nameInfo = await filenamespace.getNameInfoByName(names[i]);
      if(nameInfo.nameId > 0){
        nameInfo.isOwner = nameInfo.owner.toLowerCase() === connectState.userAddr.value.toLowerCase();
        nameInfo.updated = nameInfo.owner === nameInfo.oldOwner;
        newList.push(nameInfo);
      }
    }
    nameLists.value = newList;
  }catch(e){
    nameLists.value = new Array();
  }
  
}

const onClickToViewNameInfo = async (nameInfo:any) => {
  showNameSpaceVisiable.value = true;

  nameDetailInfo.value.nameId = nameInfo.nameId;
  nameDetailInfo.value.name = nameInfo.name;
  nameDetailInfo.value.url = nameInfo.url;
  nameDetailInfo.value.publicKey = nameInfo.publicKey;
  nameDetailInfo.value.privateKey = nameInfo.privateKey;
  nameDetailInfo.value.owner = nameInfo.owner;
  nameDetailInfo.value.oldOwner = nameInfo.oldOwner;
  nameDetailInfo.value.updated = nameInfo.updated;
  nameDetailInfo.value.isOwner = nameInfo.isOwner;

  const name = await w3name.parseName(nameInfo.publicKey);
  if(name != null){
    try{
      nameDetailInfo.value.externalInfos = new Array();
      const values = JSON.parse(await w3name.resolveName(name));
      for(const k in values){
        nameDetailInfo.value.externalInfos.push(values[k]);
      }
    }catch(e){
      nameDetailInfo.value.externalInfos = new Array();
    }
  }else{
    nameDetailInfo.value.externalInfos = new Array();
  }
}

const onClickToAddKeyValues = async () => {
  if(inputNameKey.value === '' || inputNameValue.value === ''){
    return;
  }

  nameDetailInfo.value.externalInfos.push({
    name: inputNameKey.value,
    value: inputNameValue.value,
  });

  inputNameKey.value = '';
  inputNameValue.value = '';
}

const onClickToRemoveKeyValues = async (key:string) => {
  const externalInfos = new Array();

  for(const i in nameDetailInfo.value.externalInfos){
    if(nameDetailInfo.value.externalInfos[i].name != key){
      externalInfos.push(nameDetailInfo.value.externalInfos[i]);
    }
  }

  nameDetailInfo.value.externalInfos = externalInfos;
}

const confirmNameSpaceUpdate = async () => {
  try{

    loadDrawerStatus.value = true;

    if(toRaw(avatarFileList.value).length === 1){
      nameDetailInfo.value.url = await storage.uploadFile(toRaw(avatarFileList.value)[0]);
      const tx = await filenamespace.updateAvatar(nameDetailInfo.value.nameId, nameDetailInfo.value.url);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Update name avatar success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);    
    }

    const externalInfos = {};
    for(const i in nameDetailInfo.value.externalInfos){
      const key = nameDetailInfo.value.externalInfos[i].name;
      const value = nameDetailInfo.value.externalInfos[i].value;
      if(key === null || key === undefined || key === '' || value === null || value === undefined || value === ''){
        continue;
      }
      externalInfos[key] = nameDetailInfo.value.externalInfos[i];
    }

    let privateKey = null;

    try{
      privateKey = await crypto.decryptPasswordWithWallet(JSON.parse(nameDetailInfo.value.privateKey));
    }catch(e){
      privateKey = null;
    }

    const name = await w3name.updateName(privateKey, JSON.stringify(externalInfos));

    if(name.toString() != nameDetailInfo.value.publicKey){
      privateKey = await crypto.encryptPasswordWithWallet(tools.uint8ToString(name.key.bytes));
      if(privateKey.sign_data === null || privateKey.sign_data === '' || privateKey.signature === null || privateKey.signature === ''){
      return;
      }

      const tx = await filenamespace.updateKeys(nameDetailInfo.value.nameId, name.toString(), JSON.stringify(privateKey));
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Update name keys success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);    
    }else{
      const msg = `Update name keys success!`;
      element.elMessage('success', msg, false);  
    }

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }  
}

const cancelNameSpaceUpdate = async () => {
  showNameSpaceVisiable.value = false;
}

const onClickToBurnNameInfo = async (nameInfo:any) => {
  try{
    const tx = await filenamespace.burn(nameInfo.nameId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Delete name space success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//on click to send nft token
const onClickToSendNameInfo = (nameInfo:any) => {
  const opts = {
    message: '',
    confirmButtonText: 'Send',
    cancelButtonText: 'Cancel',
    inputType: 'text',
    inputValue: '',
    inputPlaceholder: '0x0000000000000000000000000000000000000000',
    inputErrorMessage: 'Invalid address',
  };

  opts.message =  h('p', null, [
    h('p', null, 'Please enter address to send the name NFT:'),
    h('p', { style: 'color: teal' }, `name: ${nameInfo.name}`),
  ]);  

  element.elMessageBox('Please enter address to send the name NFT:', 'Send Name NFT', opts, async (name:string) => {

    name = name.trim().toLowerCase();

    let address = name;

    if(address === undefined ||
      address === null ||
      address === '' ||
      address === '0' ||
      address === '0x' ||
      address.match('0x0{1,}$') != null || 
      address === '0x000000000000000000000000000000000000dead'){
  
      name = "0x0000000000000000000000000000000000000000";
    }

    try{
      address = await resolution.addr(name, "ETH");
    }catch(e){

      try{
        address = await filenamespace.resolveByName(name);
      }catch(e){

        try{
          address = await connectState.provider.resolveName(name);
        }catch(e){
          address = null;
        }
      }
    }

    if(address === undefined || address === null || address === ''){
      element.elMessage('error', 'Invalid address input!');
      return;
    } else {
      address = address.trim().toLowerCase();
    }
    
    return sendNFT(nameInfo.name, name, address, nameInfo.nameId);

  });
}

//send a nft to a given address
const sendNFT = (nftName:string, name:string, address:string, tokenId:string) => {

  const opts = {
    message: '',
    confirmButtonText: 'Send',
    cancelButtonText: 'Cancel',
  };

  if(name === address){
    opts.message =  h('p', null, [
      h('p', null, `Are you sure to send the name NFT of ID ${tokenId} ?`),
      h('p', { style: 'color: teal' }, `name: ${nftName}`),
      h('p', { style: 'color: teal' }, 'send user: '),
      h('p', { style: 'color: teal' }, address),
    ]);
  }else{
    opts.message =  h('p', null, [
      h('p', null, `Are you sure to send the name NFT of ID ${tokenId} ?`),
      h('p', { style: 'color: teal' }, `name: ${nftName}`),    
      h('p', { style: 'color: teal' }, `send user: ${name}`),
      h('p', { style: 'color: teal' }, address),
    ]);
  }

  element.elMessageConfirm(`Are you sure to send the name NFT of ID ${tokenId} ?`, 'Send Name NFT', opts, async () => {
    try{
      await networkConnect();

      const tx = await filenamespace.transferFrom(connectState.userAddr.value, address, parseInt(tokenId));

      connectState.transactions.value.unshift(tx.hash);
      connectState.transactionCount.value++;

      const msg = `<div><span>Send success! Transaction: </span><a href="${transactionExplorerUrl(tx.hash)}" target="_blank">${tx.hash}</a></div>`

      element.elMessage('success', msg, true);    

      handleClick();      
    }catch(e){
      element.alertMessage(e);
    }
  });  
}

const getNameCount = async () => {
  const indexs = await filenamespace.getNameIndexsByPageCount(pageSize.value, pageCount.value, false);

  if(indexs.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  const nameId = Number(tools.getUrlParamter('nameId'));

  const infoList = new Array();
  for(const i in indexs){
    const res = await filenamespace.getNameInfoById(indexs[i]);

    res.isOwner = res.owner.toLowerCase() === connectState.userAddr.value.toLowerCase();
    res.updated = res.owner === res.oldOwner;

    if(nameId > 0 && nameId != res.nameId){
      continue;
    }

    infoList.push(res);
  }

  nameLists.value = infoList;
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

const handleClick = async () => {
  try{
    loadStatus.value = true;
    if (!(await connected())){
      nameLists.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    if(searchContent.value != ''){
      await onClickToSearch();
    }else{
      await getNameCount();
    }

  }catch(e){
    nameLists.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;

//update page size
handleClick();

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_drawer, {
          modelValue: showNameSpaceVisiable.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showNameSpaceVisiable).value = $event)),
          direction: "rtl",
          "destroy-on-close": ""
        }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              style: {"width":"200px"},
              drag: false,
              multiple: false,
              class: "upload-avatar",
              ref_key: "uploadAvatar",
              ref: uploadAvatar,
              action: "",
              onChange: onChangeSelectAvatarFile,
              onClick: onSelectAvatarFile,
              accept: "image/*",
              limit: 1,
              "show-file-list": false,
              "on-exceed": handleAvtarExceed,
              "auto-upload": false,
              disabled: nameDetailInfo.value.isOwner===false
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  size: 100,
                  src: nameDetailInfo.value.url
                }, null, 8, ["src"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                _createElementVNode("td", null, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    style: {"float":"left"},
                    target: "_blank",
                    href: tokenExplorerUrl(_unref(filenamespace).getAddress(), nameDetailInfo.value.nameId)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(nameDetailInfo.value.nameId), 1)
                    ]),
                    _: 1
                  }, 8, ["href"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_5,
                _createElementVNode("td", null, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    style: {"float":"left"},
                    target: "_blank",
                    href: tokenExplorerUrl(_unref(filenamespace).getAddress(), nameDetailInfo.value.nameId)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(nameDetailInfo.value.name), 1)
                    ]),
                    _: 1
                  }, 8, ["href"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_6,
                _createElementVNode("td", null, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    target: "_blank",
                    href: addressExplorerUrl(nameDetailInfo.value.owner)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tools.shortString(nameDetailInfo.value.owner)), 1)
                    ]),
                    _: 1
                  }, 8, ["href"]),
                  _createVNode(_component_el_icon, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickToCopy(nameDetailInfo.value.owner)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_document_copy)
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nameDetailInfo.value.externalInfos, (info) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: info.name
                }, [
                  (nameDetailInfo.value.isOwner || nameDetailInfo.value.updated)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                        _createElementVNode("td", null, _toDisplayString(info.name), 1),
                        _createElementVNode("td", _hoisted_8, [
                          (nameDetailInfo.value.isOwner)
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 0,
                                modelValue: info.value,
                                "onUpdate:modelValue": ($event: any) => ((info.value) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (!nameDetailInfo.value.isOwner)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(info.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (nameDetailInfo.value.isOwner)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "danger",
                                onClick: ($event: any) => (onClickToRemoveKeyValues(info.name))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Minus)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (nameDetailInfo.value.isOwner)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_input, {
                        modelValue: inputNameKey.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputNameKey).value = $event)),
                        placeholder: "Key",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_input, {
                        modelValue: inputNameValue.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputNameValue).value = $event)),
                        placeholder: "Value",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: onClickToAddKeyValues
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          footer: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              style: {"flex":"auto"},
              "element-loading-text": "Submitting...",
              "element-loading-spinner": _ctx.svg,
              "element-loading-svg-view-box": "-10, -10, 50, 50",
              "element-loading-background": "#00FFD1"
            }, [
              (nameDetailInfo.value.isOwner===true)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: cancelNameSpaceUpdate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("cancel")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nameDetailInfo.value.isOwner===true)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    onClick: confirmNameSpaceUpdate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("confirm")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_11)), [
              [_directive_loading, loadDrawerStatus.value]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"5px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": _ctx.svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#00FFD1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_input, {
                    modelValue: searchContent.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchContent).value = $event)),
                    placeholder: "Search by name or address",
                    style: {"width":"500px"},
                    size: "large",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    icon: _ctx.Search,
                    type: "primary",
                    size: "large",
                    onClick: onClickToSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Search")
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nameLists.value, (info) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: info.nameId,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, {
                        class: "box-card",
                        shadow: "always"
                      }, {
                        header: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            style: {"float":"left"},
                            target: "_blank",
                            href: tokenExplorerUrl(_unref(filenamespace).getAddress(), info.nameId)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_avatar, {
                            size: 100,
                            src: info.url
                          }, null, 8, ["src"]),
                          _createVNode(_component_el_link, {
                            target: "_blank",
                            href: addressExplorerUrl(info.owner)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tools.shortString(info.owner)) + " ", 1),
                              _createVNode(_component_el_icon, {
                                onClick: ($event: any) => (onClickToCopy(info.owner))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["href"]),
                          (info.isOwner===false)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "success",
                                size: "small",
                                style: {"float":"right"},
                                onClick: ($event: any) => (onClickToViewNameInfo(info))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (info.isOwner===true)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                type: "danger",
                                size: "small",
                                style: {"float":"right","margin-left":"5px"},
                                onClick: ($event: any) => (onClickToBurnNameInfo(info))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Burn")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (info.isOwner===true)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 2,
                                type: "warning",
                                size: "small",
                                style: {"float":"right","margin-left":"5px"},
                                onClick: ($event: any) => (onClickToSendNameInfo(info))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Send")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (info.isOwner===true)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 3,
                                type: "primary",
                                size: "small",
                                style: {"float":"right","margin-left":"5px"},
                                onClick: ($event: any) => (onClickToViewNameInfo(info))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Edit")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["element-loading-spinner"])), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Prev ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Next ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})